import popup from './popup'
import appConfig from '@/app.config.js'
class Upload {

    constructor() {

        this.file = null
        this.allowedFileSize = appConfig.allwedUploadSize
        this.allowedFileTypes = [
            'image/png',
            'image/jpeg',
            'image/jpg',
            'image/gif',
            'image/webp',
            'video/mp4',
            'video/quicktime'
        ]
    }

    addFile(file) {
        this.file = file
        if(file.type.includes('video')) {
            this.allowedFileSize = appConfig.allwedUploadVideoSize
        }

        return this
    }

    validateFileType() {

        return this.allowedFileTypes.indexOf(this.file.type) > -1
    }

    validateFileSize() {

        if (this.file.ignore_validate) {
            return true
        }

        var fileSize = Math.floor(this.file.size / 1024 / 1024)

        return fileSize < this.allowedFileSize
    }

    validate(successCallback, failCallback) {

        if (!this.validateFileType() || this.file.type.includes("video")) {

            popup.alert("Please upload only image file")

            if (typeof failCallback == 'function') {
                failCallback()
            }

            return false
        }

        if (!this.validateFileSize()) {

            popup.alert("Your image large than " + this.allowedFileSize + "MB")

            if (typeof failCallback == 'function') {
                failCallback()
            }

            return false
        }

        successCallback()
        return true
    }

    validateVideo(successCallback, failCallback) {

        if (!this.validateFileType() || this.file.type.includes("image")) {

            popup.alert("Please upload only MP4 file")

            if (typeof failCallback == 'function') {
                failCallback()
            }

            return false
        }

        if (!this.validateFileSize()) {

            popup.alert("Your video large than " + this.allowedFileSize + "MB")

            if (typeof failCallback == 'function') {
                failCallback()
            }

            return false
        }



        successCallback()
        return true
    }
}

export default new Upload
